export const FEEDBACK_ENTRIES_SUBMITTED = 'FEEDBACK_ENTRIES_SUBMITTED';
export const SELECTED_LANGUAGE = 'SELECTED_LANGUAGE';
export const ENROLL_EVENT_REPORT = 'ENROLL_EVENT_REPORT';
export const REGISTRATION_ID = 'REGISTRATION_ID';
export const ENROLLED_USER_SESSION = 'ENROLLED_USER_SESSION';
